





















import { Component, Vue, Prop } from "vue-property-decorator";

@Component({ components: {} })
export default class RankList extends Vue {
  private arrow: string = "never";

  // 0:图书 1:听书
  @Prop() private type!: number;
  @Prop() private datas!: [];
  @Prop() private radiusDot!: boolean;

}
